"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immer = _interopRequireDefault(require("immer"));

var _uid = require("../utils/uid");

var _proptypes = require("../utils/proptypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var TREE_TABLE_DEFAULT_INDENT = 25;

var _default = function _default(WrappedComponent) {
  var TreeExpand =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(TreeExpand, _React$Component);

    function TreeExpand(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.handleTreeExpand = _this.handleTreeExpand.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.expandLevel = new Map();
      _this.state = {
        expandKeys: new Map()
      };
      return _this;
    }

    var _proto = TreeExpand.prototype;

    _proto.getTreeIndent = function getTreeIndent() {
      var columns = this.props.columns;

      for (var i = 0; i < columns.length; i++) {
        if (typeof columns[i].treeIndent === 'number') return columns[i].treeIndent;
      }

      return TREE_TABLE_DEFAULT_INDENT;
    };

    _proto.getChildrenLength = function getChildrenLength(children) {
      var _this$props = this.props,
          treeColumnsName = _this$props.treeColumnsName,
          keygen = _this$props.keygen;
      var expandKeys = this.state.expandKeys;
      if (!children) return 0;
      var _children$length = children.length,
          length = _children$length === void 0 ? 0 : _children$length;

      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        var key = (0, _uid.getKey)(child, keygen);
        if (!expandKeys.get(key)) continue;
        expandKeys.delete(key);

        if (child[treeColumnsName] && child[treeColumnsName].length) {
          length += this.getChildrenLength(child[treeColumnsName]);
        }
      }

      return length;
    };

    _proto.getExpandData = function getExpandData() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          keygen = _this$props2.keygen,
          treeColumnsName = _this$props2.treeColumnsName;
      var expandKeys = this.state.expandKeys;
      if (expandKeys.size === 0) return data;
      var storeExpandKeys = new Map();
      expandKeys.forEach(function (value, key) {
        return storeExpandKeys.set(key, value);
      });
      return (0, _immer.default)(data, function (draft) {
        var dataCo = draft;

        for (var i = 0; i < dataCo.length; i++) {
          if (storeExpandKeys.size === 0) break;
          var item = dataCo[i];
          var key = (0, _uid.getKey)(item, keygen, i);

          if (storeExpandKeys.get(key) && item[treeColumnsName]) {
            draft.splice.apply(draft, [i + 1, 0].concat(item[treeColumnsName]));
            dataCo = draft;
            storeExpandKeys.delete(key);
          }
        }
      });
    };

    _proto.handleTreeExpand = function handleTreeExpand(data, index) {
      var _this2 = this;

      var _this$props3 = this.props,
          treeColumnsName = _this$props3.treeColumnsName,
          keygen = _this$props3.keygen;
      var expandKeys = this.state.expandKeys;
      var children = data[treeColumnsName];
      var key = (0, _uid.getKey)(data, keygen, index);
      var parentLevel = this.expandLevel.get(key) || 0;

      if (expandKeys.get(key)) {
        this.setState((0, _immer.default)(function (draft) {
          return draft.expandKeys.delete(key);
        }));
      } else {
        children.forEach(function (child, i) {
          _this2.expandLevel.set((0, _uid.getKey)(child, keygen, index + i + 1), parentLevel + 1);
        });
        this.setState((0, _immer.default)(function (draft) {
          return draft.expandKeys.set(key, true);
        }));
      }
    };

    _proto.render = function render() {
      var treeColumnsName = this.props.treeColumnsName;
      var expandKeys = this.state.expandKeys;
      var data = this.getExpandData();
      var rootTree = data.filter(function (v) {
        return v && v[treeColumnsName] && v[treeColumnsName].length;
      }).length === 0;
      var treeIndent = this.getTreeIndent();
      return _react.default.createElement(WrappedComponent, _extends({}, this.props, {
        data: data,
        onTreeExpand: this.handleTreeExpand,
        treeExpandKeys: expandKeys,
        treeExpandLevel: this.expandLevel,
        treeRoot: rootTree,
        treeIndent: treeIndent
      }));
    };

    return TreeExpand;
  }(_react.default.Component);

  TreeExpand.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'keygen'), {
    data: _propTypes.default.arrayOf(_propTypes.default.object),
    treeColumnsName: _propTypes.default.string
  });
  return TreeExpand;
};

exports.default = _default;